import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Screenshot.module.css';

interface ScreenshotProps {
  helpKey: string;
  alt: string;
  lang?: string;
}

// תבנית בטוחה למניעת path traversal — kebab-case בלבד
const SAFE_KEY_RE = /^[a-zA-Z0-9_-]+$/;

export const Screenshot: React.FC<ScreenshotProps> = ({ helpKey, alt, lang }) => {
  const { i18n } = useTranslation();
  const resolvedLang = lang ?? (i18n.language === 'en' ? 'en' : 'he');

  // hooks קודם לכל return — כנדרש ב-rules-of-hooks
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  // בדיקת בטיחות — helpKey ו-lang חייבים alphanumeric+hyphen בלבד
  if (!SAFE_KEY_RE.test(helpKey) || !SAFE_KEY_RE.test(resolvedLang)) {
    return null;
  }

  const src = `/help-assets/${resolvedLang}/${helpKey}.png`;

  if (error) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.placeholder} aria-label="צילום מסך אינו זמין">
          <span className={styles.placeholderIcon} aria-hidden="true">📷</span>
          <span>צילום מסך אינו זמין</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {!loaded && <div className={styles.skeleton} aria-hidden="true" />}
      <img
        src={src}
        alt={alt}
        className={styles.image}
        style={loaded ? {} : { display: 'none' }}
        loading="eager"
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
      />
    </div>
  );
};
